import { render, staticRenderFns } from "./AdminClient.vue?vue&type=template&id=7823eace&"
import script from "./AdminClient.vue?vue&type=script&lang=js&"
export * from "./AdminClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports